module.exports = __webpack_public_path__ + "static/media/lu.229c0656.svg";